import styled from "styled-components";

export const SelectCategory = styled.div`
  margin-bottom: 35px;

  & h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 21px;
  }

  & .categoryOptions {
    display: flex;

    & .categoryOption {
      display: flex;
      align-items: center;
      margin-right: 23px;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;

      & .icon {
        margin-right: 7px;
      }

      & .flightIcon {
        background-position: -61px -7.5px;
        width: 23px;
        height: 13px;
      }

      & .hotelIcon {
        background-position: -95px 0px;
        width: 24px;
        height: 22px;
      }

      & .insuranceIcon {
        width: 19px;
        height: 22px;
        background-position: -35px -79px;
      }

      & .visaIcon {
        background-position: -84px -75px;
        width: 14px;
        height: 25px;
      }
    }

    & label {
      display: flex;
      align-items: center;
    }

    & input {
      margin-right: 11px;
      height: 18px;
      width: 18px;
    }

    & input[type="radio"]:checked + label {
      font-weight: 900;

      & .flightIcon {
        background-position: -61px -33.5px;
      }

      & .hotelIcon {
        background-position: -95px -25px;
      }

      & .insuranceIcon {
        background-position: -57px -78px;
      }

      & .visaIcon {
        background-position: -104px -75px;
      }
    }
  }
`;
